export default "<ion-app>\n  <ion-router-outlet [animation]=\"defaultPageTransition\"></ion-router-outlet>\n</ion-app>";